const theme = {
  breakpoints: {
    small: '481px',
    medium: '737px',
    large: '981px',
    xlarge: '1281px',
  },

  size: {
    small: '720px',
    medium: '900px',
    sidebarLayout: '1160px',
    large: '1300px',
  },

  space: [
    '0.25rem', // 0, 4px
    '0.5rem', // 1, 8px
    '0.75rem', // 2, 12px
    '1rem', // 3, 16px
    '1.25rem', // 4, 20px
    '1.5rem', // 5, 24px
    '2rem', // 6, 32px
    '3rem', // 7, 48px
    '4rem', // 8, 64px
    '5rem', // 9, 80px
    '5.75rem', //10, 92px
  ] as const,

  fontSizes: [
    '0.75rem', // 1, 12px
    '1rem', // 2, 16px
    '1.25rem', // 3, 20px
    '1.5rem', // 4, 24px
    '2rem', // 5, 32px
    '2.25rem', // 6, 36px
    '2.5rem', // 7, 40px
    '3rem', // 8, 48px
  ] as const,

  radii: {
    small: '3px',
    medium: '6px',
    large: '12px',
    extralarge: '24px',
  },

  colors: {
    dataLightblue: '#64C2D7',
    dataGreen: '#55AF7D',
    dataPurple: '#645ACB',
    dataPink: '#E767C1',
    dataLightpurple: '#A0A3FD',
    dataBlue: '#174EA1',
    dataCoffee: '#AD7C6D',
    dataTan: '#9DB286',
    dataYellow: '#FFB14E',
    dataRed: '#EF6B6B',
    dataGrey: '#C0C6D0',
    hoverHighlight: '#E7EEF9',
    quoteBlue: '#1D2587',
    black100: '#D9DCDE',
    black500: '#6E7489',
    black600: '#595F72',
    black900: '#09083e',
    blue50: '#F0F4FA',
    blue900: '#060C22',
    green600: '#218D56',
    heading: '#1A66D8',
    linkUnderline: '#FFC3D2',
    linkUnderlineHover: '#EA5F94',
  },

  shadows: {
    soft: '0px 0px 38px 0px rgba(0, 0, 0, 0.03), 0px 0px 38px rgba(23, 23, 26, 0.05)',
  },
}

/**
 * @deprecated Use styles/theme instead, if writing new code.
 */
export default theme
